import { Component, inject } from '@angular/core';
import {NgStyle} from "@angular/common";
import { DataService } from 'src/app/service/data.service';


@Component({
    selector: 'user-count',
    imports: [
        NgStyle
    ],
    templateUrl: './user-count.component.html'
})

export class UserCountComponent {
    protected dataService = inject(DataService);


    public userCount;

    ngOnInit() {

        this.fillUserCountVar();
        

    }

    private async fillUserCountVar() {
        
         this.userCount = await this.dataService.getUserCount();

    }
}
